import {
  Drawer,
  DrawerOverlay,
  DrawerContent,
  type DrawerContentProps,
} from '@chakra-ui/react';
import { type FC } from 'react';

import { usePortalContainer } from '$/contexts/PortalContainerContext';
import { isSafari } from '$/utils/userAgent';

interface Props extends DrawerContentProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  closeOnOverlayClick?: boolean;
}

export const MobileDrawer: FC<Props> = ({
  children,
  isOpen,
  onClose,
  closeOnOverlayClick,
  ...rest
}) => {
  const portalContainerRef = usePortalContainer();

  return (
    <Drawer
      // Drawer uses autoFocus to focus the first focusable element in the drawer, which creates bugs on ios
      // eslint-disable-next-line jsx-a11y/no-autofocus
      autoFocus={!isSafari()}
      closeOnOverlayClick={closeOnOverlayClick}
      isOpen={isOpen}
      onClose={onClose}
      placement='bottom'
      portalProps={{ containerRef: portalContainerRef }}
      size='full'
    >
      <DrawerOverlay />
      <DrawerContent
        overflowY='auto'
        maxH='98dvh'
        bg='background'
        borderRadius='12px 12px 0 0'
        {...rest}
      >
        {children}
      </DrawerContent>
    </Drawer>
  );
};
